import React from "react";
import { useMsal } from "@azure/msal-react";
import { Button } from "@mui/material";

import "./signInout.css";

/**
 * Renders a button which, when selected, will open a popup for logout
 */
export const SignOutButton = () => {
  const { instance } = useMsal();

  const handleLogout = (logoutType) => {
    if (logoutType === "popup") {
      localStorage.clear();
      instance.logoutRedirect({
        postLogoutRedirectUri: "/",
      });
    }
  };

  return (
    <Button
      color="inherit"
      className="sign-out-button"
      sx={{ fontFamily: "Open Sans", fontSize: "14px" }}
      onClick={() => handleLogout("popup")}
    >
      Sign out
    </Button>
  );
};
